import styled from '@emotion/styled'

import { theme } from '../Theme'

const ConstrainToColumn = styled.div`
  ${theme.layout.fluidWidth(theme.maxWidths.column)};
`

export default ConstrainToColumn
